import React, { useState } from 'react';
import { useQueryClient } from 'react-query';
import { func, string } from 'prop-types';

import InfoModal from '../InfoModal';

import ActionClassifier from './ActionClassifier';
import ActionTagging from './ActionTagging';
import ActionMultilabel from './ActionMultilabel';

import './TileActions.scss';

export default function TileActions({ patchChecks, indexName, checkId }) {
  const queryClient = useQueryClient();
  const singleMissionData = queryClient.getQueryData('single mission', { exact: false });
  const {
    mission: { labelingType },
    missionEntities,
  } = singleMissionData;

  const [showInfoModal, setShowInfoModal] = useState(false);

  return (
    <div className="TileActions">
      {labelingType === 'tagging' && <ActionTagging patchChecks={patchChecks} />}

      {labelingType === 'classifier' && (
        <ActionClassifier
          checkId={checkId}
          indexName={indexName}
          entities={missionEntities}
          patchChecks={patchChecks}
        />
      )}

      {labelingType === 'multilabel' && (
        <ActionMultilabel
          checkId={checkId}
          indexName={indexName}
          entities={missionEntities}
          patchChecks={patchChecks}
        />
      )}
      <div className="Info__wrapper">
        <button
          type="button"
          onClick={() => {
            setShowInfoModal(true);
          }}
        >
          i
        </button>
      </div>

      {showInfoModal && (
        <InfoModal
          checkId={checkId}
          onClose={() => {
            setShowInfoModal(false);
          }}
        />
      )}
    </div>
  );
}

TileActions.propTypes = {
  checkId: string.isRequired,
  indexName: string.isRequired,
  patchChecks: func.isRequired,
};
